import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';
import { CouponListModalComponent } from '../coupon-list-modal/coupon-list-modal.component';

@Component({
  selector: 'app-user-affiliate-create-coupon',
  templateUrl: './user-affiliate-create-coupon.component.html',
  styleUrls: ['./user-affiliate-create-coupon.component.scss'],
})
export class UserAffiliateCreateCouponComponent {
  code = '';
  constructor(
    private dialog: MatDialog,
    private api: UserApiService,
    private message: MessageService
  ) {}

  onOk() {
    if (!this.code) {
      this.message.warn('请输入优惠码');
      return;
    }
    this.createCoupon();
  }

  openModal() {
    this.dialog.open(CouponListModalComponent);
  }

  loading = false;
  async createCoupon() {
    try {
      this.loading = true;
      const r = await this.api.createCoupon(this.code);
      if (r.status === 13006) {
        this.message.warn('优惠码限制为4至8位英文+数字');
      } else if (r.status === 13005) {
        this.message.warn('优惠码已存在，请修改');
      } else if (r.status === 13008) {
        this.message.warn('优惠码数量已达上限');
      } else {
        this.message.open('创建成功');
        window.location.reload();
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
